(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/promos/views/promo.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/promos/views/promo.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.promos.views.Promo = Backbone.Marionette.CompositeView.extend({
    initBackgroundImage: function() {
      var self = this;

      this.backgroundUrl = this.model.get('backgroundImageLarge');
      this.isResponsive = this.backgroundUrl ?
          this.backgroundUrl.indexOf('{width}') > 0 :
          false;
      this.currentImageWidth = 0;

      if (this.backgroundUrl) {
        if (this.isResponsive) {
          this.updateLayoutBind = _.debounce(function() {
            self.loadBackgroundImage();
          }, 1000);
          window.addEventListener('resize', this.updateLayoutBind, this);
        }
        this.loadBackgroundImage(true);
      }
    },
    customDestroy: function() {
      if (this.updateLayoutBind) {
        window.removeEventListener('resize', this.updateLayoutBind, this);
      }
      this.destroy();
    },
    loadBackgroundImage: function(fade) {
      var self = this;
      var cssProps;
      var backgroundImgLoader = new Image();
      var backgroundUrl;
      var backgroundObj = this.ui.background;
      var backgroundOverlay = this.ui.backgroundOverlay;
      var imageWidth;

      if (this.isResponsive) {
        imageWidth = svs.content.responsiveImage.bestFit({
          elWidth: this.$el.width()
        });

        if (imageWidth > this.currentImageWidth) {
          this.currentImageWidth = imageWidth;

          backgroundUrl = this.backgroundUrl.replace(
            '{width}',
            this.currentImageWidth
          );
        }
      } else {
        backgroundUrl = this.backgroundUrl;
      }

      if (backgroundUrl) {
        if (backgroundUrl.indexOf('/cms/') >= 0) {
          backgroundUrl = svs.core.config.data.svsconfig.cdn2 + backgroundUrl;
        } else {
          backgroundUrl = svs.core.config.data.svsconfig.cdn + backgroundUrl;
        }

        if (fade) {
          if (!svs.core.detect.formfactor.mobile()) {
            cssProps = {
              opacity: 0,
              '-webkit-transform': 'translate3d(0,-10px,0)',
              '-moz-transform': 'translate3d(0,-10px,0)',
              '-ms-transform': 'translate3d(0,-10px,0)',
              '-o-transform': 'translate3d(0,-10px,0)',
              transform: 'translate3d(0,-10px,0)'
            };
          } else {
            cssProps = {
              opacity: 0
            };
          }
          backgroundObj.css(cssProps);
          if (backgroundOverlay) {
            backgroundOverlay.css('opacity', '0');
          }
        }

        backgroundImgLoader.onload = function() {
          backgroundObj.css('background-image', 'url(' + backgroundUrl + ')');
          if (fade) {
            setTimeout(
              function() {
                cssProps = {
                  '-webkit-transition':
                      '.4s -webkit-transform ease, .4s opacity ease',
                  '-moz-transition':
                      '.4s -moz-transform ease, .4s opacity ease',
                  '-ms-transition':
                      '.4s -ms-transform ease, .4s opacity ease',
                  '-o-transition': '.4s -o-transform ease, .4s opacity ease',
                  transition: '.4s transform ease, .4s opacity ease',
                  '-webkit-transform': 'translate3d(0, 0, 0)',
                  '-moz-transform': 'translate3d(0, 0, 0)',
                  '-ms-transform': 'translate3d(0, 0, 0)',
                  '-o-transform': 'translate3d(0, 0, 0)',
                  transform: 'translate3d(0, 0, 0)',
                  opacity: 1
                };
                backgroundObj.css(cssProps);
                if (backgroundOverlay) {
                  backgroundOverlay.css(cssProps);
                }
              },
                self.options.itemIndex ? 100 * self.options.itemIndex : 100
            );
          }
        };

        backgroundImgLoader.src = backgroundUrl;
      }
    }
  });
})(Backbone, _, svs);

 })(window);